import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SwitchDirective } from "./switch.directive";
import { SwitchComponent } from "./switch.component";

@NgModule({
  imports: [CommonModule],
  declarations: [SwitchComponent, SwitchDirective],
  exports: [SwitchComponent, SwitchDirective]
})
export class SwitchModule {}
